import { ReactNode, useState } from 'react'

import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/dialog'

type Props = {
  defaultOpen?: boolean
  onOpenChange?(open: boolean): void
  title: string
  trigger: ReactNode
  youtubeId: string
}

export const VideoPlayerDialog = ({
  defaultOpen,
  onOpenChange,
  title,
  trigger,
  youtubeId,
}: Props) => {
  const [open, setOpen] = useState(defaultOpen ?? false)

  const handleOpenChange = (next: boolean) => {
    setOpen(next)
    onOpenChange?.(next)
  }

  return (
    <Dialog onOpenChange={handleOpenChange} open={open}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-3xl">
        <DialogTitle>{title}</DialogTitle>
        <div className="aspect-video overflow-hidden rounded-lg">
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="h-full w-full"
            src={`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&cc_load_policy=0`}
            title={title}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default VideoPlayerDialog
